<template>
    <div class="w-full flex justify-content-start mb-3">
        <Button label="Создать кошелек" @click="displayDialog = true" icon="pi pi-plus" iconPos="right" size="small"/>
    </div>

    <Dialog header="Создание кошельков" class="flex flex-column" modal
        v-model:visible="displayDialog" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '38vw'}"
        @hide="resetForm">

        <div class="flex flex-column gap-4">
            <div class="surface-50 border-round-lg p-3">
                <div class="flex flex-column w-full mb-3">
                    <span class="flex mb-2 font-medium">Виртуальный кошелек</span>
                    <span class="text-600 text-sm mb-3">Создание через create_wallet</span>
                </div>

                <div class="flex flex-column w-full mb-3">
                    <span class="flex mb-2">ID пользователя:</span>
                    <InputText v-model="virtualWallet.user_id" class="flex" />
                </div>

                <div class="flex flex-column w-full mb-3">
                    <span class="flex mb-2">Тип:</span>
                    <Select v-model="virtualWallet.type" :options="virtualWalletTypes" optionLabel="name" optionValue="code"
                        placeholder="Выберите тип" class="w-full"/>
                </div>

                <div class="w-full">
                    <Button label="Создать виртуальный" @click="createVirtualWallet()" :loading="loadingVirtual"
                        :disabled="!canCreateVirtual || loadingDeposit" class="w-full"/>
                </div>
            </div>

            <div class="surface-50 border-round-lg p-3">
                <div class="flex flex-column w-full mb-3">
                    <span class="flex mb-2 font-medium">Депозитный кошелек</span>
                    <span class="text-600 text-sm mb-3">Создание через AdminCreateDepositWallet</span>
                </div>

                <div class="flex flex-column w-full mb-3">
                    <span class="flex mb-2">ID пользователя:</span>
                    <InputText v-model="depositWallet.user_id" class="flex" />
                </div>

                <div class="flex flex-column w-full mb-3">
                    <span class="flex mb-2">Валюты:</span>
                    <SelectButton v-model="depositWallet.currencies" :options="depositWalletCurrencies" optionLabel="name" optionValue="code" multiple aria-labelledby="deposit-wallet-currencies">
                        <template #option="slotProps">
                            <span class="text-xs py-1 white-space-nowrap">{{ slotProps.option.name }}</span>
                        </template>
                    </SelectButton>
                </div>

                <div class="w-full">
                    <Button label="Создать депозитный" @click="createDepositWallet()" :loading="loadingDeposit"
                        :disabled="!canCreateDeposit || loadingVirtual" class="w-full"/>
                </div>
            </div>
        </div>
    </Dialog>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'

export default {
    name: 'AddWallet',
    data() {
        return {
            displayDialog: false,
            loadingVirtual: false,
            loadingDeposit: false,
            virtualWalletTypes: [
                {name: 'partner', code: 'partner'},
                {name: 'merchant', code: 'merchant'},
                {name: 'vcard', code: 'vcard'},
                {name: 'user', code: 'user'},
                {name: 'vendor', code: 'vendor'},
                {name: 'fund', code: 'fund'},
            ],
            depositWalletCurrencies: [
                {name: 'usdt', code: 'usdt'},
                {name: 'usdt_trc', code: 'usdt_trc'},
                {name: 'bnb', code: 'bnb'},
                {name: 'trx', code: 'trx'},
            ],
            virtualWallet: {
                user_id: null,
                type: null,
            },
            depositWallet: {
                user_id: null,
                currencies: [],
            },
        }
    },
    computed: {
        canCreateVirtual() {
            return !!this.virtualWallet.user_id && !!this.virtualWallet.type
        },
        canCreateDeposit() {
            return this.depositWallet.currencies && this.depositWallet.currencies.length > 0
        },
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({severity, summary, detail, life: 3000})
        },
        resetForm() {
            this.virtualWallet = {
                user_id: null,
                type: null,
            }
            this.depositWallet = {
                user_id: null,
                currencies: [],
            }
            this.loadingVirtual = false
            this.loadingDeposit = false
        },
        handleErrors(response, fallbackText) {
            if (response && response.errors && response.errors.length > 0) {
                this.showMess('error', 'Ошибка', response.errors[0])
            } else {
                this.showMess('error', 'Ошибка', fallbackText)
            }
        },
        async createVirtualWallet() {
            if (!this.canCreateVirtual) return false
            this.loadingVirtual = true

            const response = await this.connect.create_wallet({
                user_id: this.virtualWallet.user_id,
                type: this.virtualWallet.type,
            }).then(res => res).catch(err => err)

            if (response && response.result) {
                this.showMess('success', 'Успешно', 'Виртуальный кошелек создан')
                this.$emit('reload')
                this.displayDialog = false
                this.resetForm()
            } else {
                this.handleErrors(response, 'Ошибка создания виртуального кошелька')
            }

            this.loadingVirtual = false
        },
        async createDepositWallet() {
            if (!this.canCreateDeposit) return false
            this.loadingDeposit = true

            const response = await this.connect.AdminCreateDepositWallet({
                user_id: this.depositWallet.user_id,
                currencies: this.depositWallet.currencies,
            }).then(res => res).catch(err => err)

            if (response && response.result) {
                this.showMess('success', 'Успешно', 'Депозитный кошелек создан')
                this.$emit('reload')
                this.displayDialog = false
                this.resetForm()
            } else {
                this.handleErrors(response, 'Ошибка создания депозитного кошелька')
            }

            this.loadingDeposit = false
        },
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>